import { Link, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '@sentinel/ui';

const navListStyle: React.CSSProperties = {
  display: 'grid',
  gap: '0.5rem',
  margin: 0,
  padding: 0,
  listStyle: 'none',
};
const navLinkStyle: React.CSSProperties = {
  display: 'block',
  padding: '0.875rem 1rem',
  borderRadius: 10,
  border: '1px solid rgba(245,247,255,0.08)',
  textDecoration: 'none',
  color: 'inherit',
  background: 'rgba(245,247,255,0.02)',
  transition: 'background 200ms cubic-bezier(0.16, 1, 0.3, 1)',
};
const navLabelStyle: React.CSSProperties = {
  fontSize: 14,
  color: 'rgba(245,247,255,0.6)',
  marginTop: 4,
};

function AccountHubPage() {
  const { t } = useTranslation('security');
  const { t: ts } = useTranslation('sessions');
  const { t: td } = useTranslation('data');
  const { t: tc } = useTranslation('credentials');
  const { t: tal } = useTranslation('audit-log');
  const { t: ta } = useTranslation('account');
  const { t: tp } = useTranslation('profile');
  const { t: tca } = useTranslation('connected-apps');
  return (
    <PageLayout title={ta('hub_title')} subtitle={ta('hub_subtitle')}>
      <ul style={navListStyle}>
        <li>
          <Link to="/account/profile" style={navLinkStyle} data-testid="account-link-profile">
            <strong>{tp('title')}</strong>
            <div style={navLabelStyle}>{tp('hub_subtitle')}</div>
          </Link>
        </li>
        <li>
          <Link to="/account/security" style={navLinkStyle} data-testid="account-link-security">
            <strong>{t('title')}</strong>
            <div style={navLabelStyle}>{t('subtitle')}</div>
          </Link>
        </li>
        <li>
          <Link
            to="/account/credentials"
            style={navLinkStyle}
            data-testid="account-link-credentials"
          >
            <strong>{tc('title')}</strong>
            <div style={navLabelStyle}>{tc('hub_subtitle')}</div>
          </Link>
        </li>
        <li>
          <Link to="/account/sessions" style={navLinkStyle} data-testid="account-link-sessions">
            <strong>{ts('title')}</strong>
            <div style={navLabelStyle}>{ts('subtitle')}</div>
          </Link>
        </li>
        <li>
          <Link
            to="/account/connected-apps"
            style={navLinkStyle}
            data-testid="account-link-connected-apps"
          >
            <strong>{tca('title')}</strong>
            <div style={navLabelStyle}>{tca('hub_subtitle')}</div>
          </Link>
        </li>
        <li>
          <Link
            to="/account/audit-log"
            style={navLinkStyle}
            data-testid="account-link-audit-log"
          >
            <strong>{tal('title')}</strong>
            <div style={navLabelStyle}>{tal('subtitle')}</div>
          </Link>
        </li>
        <li>
          <Link to="/account/data" style={navLinkStyle} data-testid="account-link-data">
            <strong>{td('title')}</strong>
            <div style={navLabelStyle}>{td('subtitle')}</div>
          </Link>
        </li>
      </ul>
    </PageLayout>
  );
}

export const Route = createFileRoute('/account/')({
  component: AccountHubPage,
});
